import { Paragraph1 } from 'inpock-ui-react';

import { Icon } from '../Icon';

import * as S from './styled';

interface QuantityControllerProps {
  quantity: number;
  minus: {
    onClick: () => void;
    disabled?: boolean;
  };
  plus: {
    onClick: () => void;
    disabled?: boolean;
  };
  disabled?: boolean;
}

export function QuantityController(props: QuantityControllerProps) {
  return (
    <S.QuantityControllerContainer disabled={props.disabled}>
      <S.IconContainer
        direction="left"
        onClick={() => {
          if (props.disabled || props.minus.disabled) return;
          props.minus.onClick();
        }}
      >
        <Icon icon="MinusLight" size={14} disabled={props.minus.disabled || props.disabled} />
      </S.IconContainer>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ padding: '0 8px', minWidth: '28px' }}
      >
        <Paragraph1 style={{ whiteSpace: 'nowrap' }}>{props.quantity}</Paragraph1>
      </div>
      <S.IconContainer
        direction="right"
        onClick={() => {
          if (props.disabled) return;
          props.plus.onClick();
        }}
      >
        <Icon icon="PlusLight" size={14} disabled={props.plus.disabled || props.disabled} />
      </S.IconContainer>
    </S.QuantityControllerContainer>
  );
}
